(function flexible (window, document) {
  var docEl = document.documentElement
  var dpr = window.devicePixelRatio || 1
  // 设计稿基准：wc2026 = 750，ann2026 = 752（rem 封顶与 postcss rootValue 保持一致）
  const pcList = [
    { path: 'wc2026', max: 75 },
    { path: 'ann2026', max: 75.2 }
  ]
  // adjust body font size
  function setBodyFontSize () {
    if (document.body) {
      document.body.style.fontSize = (12 * dpr) + 'px'
    }
    else {
      document.addEventListener('DOMContentLoaded', setBodyFontSize)
    }
  }
  setBodyFontSize();
   
   
  //这里也是设置的份数,也是用10
  // set 1rem = viewWidth / 10 
  // 把屏幕平均分成10等份。比如1920/10= 192 px,这个时候1rem就是192px,配合vscod插件快速适配，在style中使用媒体查询。
  function setRemUnit () {
    var rem = docEl.clientWidth / 10
    var olfFontSize = parseFloat(docEl.style.fontSize)
    const matched = pcList.find(item => window.location.pathname.includes(item.path))
    if (matched) {
      rem = Math.min(rem, matched.max)
    }
    if (olfFontSize !== rem) {
      docEl.style.fontSize = rem + 'px'
    }
  }

  setRemUnit()
  window.setRemUnit = setRemUnit

  // reset rem unit on page resize
  window.addEventListener('resize', setRemUnit)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      setRemUnit()
    }
  })

  // pc上初始化时没有滚动条，当有滚动条时，需要重新计算rem
  const resizeObserver = new ResizeObserver(entries => {
    // eslint-disable-next-line no-unused-vars
    for (let entry of entries) {
      // 检测clientWidth变化，可能表示滚动条出现/消失
      setRemUnit();
    }
  });

  // 监听html元素尺寸变化
  resizeObserver.observe(docEl);

  // detect 0.5px supports
  if (dpr >= 2) {
    var fakeBody = document.createElement('body')
    var testElement = document.createElement('div')
    testElement.style.border = '.5px solid transparent'
    fakeBody.appendChild(testElement)
    docEl.appendChild(fakeBody)
    if (testElement.offsetHeight === 1) {
      docEl.classList.add('hairlines')
    }
    docEl.removeChild(fakeBody)
  }
}(window, document));